var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a-row',{attrs:{"gutter":10}},[_c('a-col',{attrs:{"span":4}},[_c('Template',{on:{"success":_vm.setCurrItem}})],1),_c('a-col',{attrs:{"span":20}},[_c('List',{ref:"list"})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }